import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper, Select, Text
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";

interface ICondicaoPagamentoForm {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: CondicaoPagamento;
  error: boolean;
  textColor: string;
  brandStars: string;
  nome: string;

  loading: boolean;
  save: () => void;
  changeInput: (tipo: string, value: string) => void;
  cancelRef: any;
  closeError: () => void;
  errorTitle: string;
  errorMsg: string;
}
const CondicaoPagamentoForm = ({
  show,
  showModal,
  accountSelected,
  error,
  textColor,
  brandStars,
  nome,

  changeInput,
  loading,
  save,
  cancelRef,
  closeError,
  errorMsg,
  errorTitle,
}: ICondicaoPagamentoForm) => {
  return (
    <Modal
      onClose={() => {
        showModal(false);
      }}
      size={"2xl"}
      isOpen={show}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {accountSelected !== null
            ? "Editar Condição de Pagamento"
            : "Nova Condição de Pagamento"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Nome<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              defaultValue={accountSelected?.nome}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o nome da Forma Pagamento"
              onChange={(e) => changeInput("nome", e.target.value)}
              mb="16px"
              fontWeight="500"
              size="lg"
            />
          </FormControl>
          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Parcelas
            </FormLabel>
            <NumberInput
              step={10}
              max={100}
              min={0}
              defaultValue={accountSelected?.parcelas}
              onChange={(e: string) => changeInput("parcelas", e)}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>


          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              mt={4}
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Entrada 
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => changeInput('entrada', e.target.value)}
              defaultValue={accountSelected?.entrada ? 'true' : 'false'}
            >
              <option value="false">Não</option>
              <option value="true">Sim
              </option>

            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              mt={4}
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Baixa da Primeira Parcela? 
            </FormLabel>

            <Select
              size="md"
              onChange={(e) => changeInput('baixaPrimeira', e.target.value)}
              defaultValue={accountSelected?.baixaPrimeira ? 'true' : 'false'}
            >
              <option value="false">Não</option>
              <option value="true">Sim
              </option>

            </Select>
          </FormControl>


          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              mt={4}
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Dia Fixo
            </FormLabel>
            <NumberInput
              step={10}
              max={100}
              min={0}
              defaultValue={accountSelected?.diaFixo}
              onChange={(e: string) => changeInput("diaFixo", e)}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>

        
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Modal>
  );
};
export default CondicaoPagamentoForm;
